import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import simplebar from "simplebar-vue";
import { interpret } from "xstate";
// SYSTEM1
import { toaster } from "@/utilities/toaster";
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import EcTextEditor from "@/components/widgets/EcTextEditor.vue";
import CommentComponent from "./CommentComponent.vue";
import qnaMachine from "../machines/qnaMachine";
import { PAReviewAnswerItemModel } from "@/store/models/paReview/paReviewAnswerItemDTO";
import { qnaFlagsType } from "@/store/models/paReview/paReviewFormDetailItemDTO";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import { PAReviewCommentItemModel } from "@/store/models/paReview/paReviewCommentItemDTO";
import { PAReviewModule } from "@/store/modules/paReview.module";
import _ from "lodash";
let QuestionAndAnswerComponent = /** @class */ (() => {
    var _a, _b;
    let QuestionAndAnswerComponent = class QuestionAndAnswerComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.isAnswerDirty = false;
            //   MACHINE
            this.machine = qnaMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.editorContent = "";
        }
        initialize() {
            this.send({ type: "INITIALIZE", answerText: this.questionAnswerAndComments.answerText });
            this.editorContent = this.questionAnswerAndComments.answerText;
            this.newComment = new PAReviewCommentItemModel();
            this.newComment.paCycleReviewAnswerId = this.questionAnswerAndComments.id;
        }
        send(event) {
            this.machineService.send(event);
        }
        editorContentChanged(text) {
            this.isAnswerDirty = true;
            this.editorContent = text;
        }
        showEditor() {
            this.send({ type: "SHOW_EDITOR" });
        }
        saveAnswer() {
            if (!PAReviewModule.openedByClient) {
                this.validateAnswer().then((isValid) => {
                    if (isValid) {
                        const { answerText, ...restOfQNA } = this.questionAnswerAndComments;
                        const updatedQna = { ...restOfQNA, answerText: this.editorContent };
                        this.send({ type: "SAVE_ANSWER", qna: updatedQna });
                        this.isAnswerDirty = false;
                    }
                });
            }
            else {
                this.validateAnswer().then((isValid) => {
                    if (isValid) {
                        const { answerText, ...restOfQNA } = this.questionAnswerAndComments;
                        const updatedQna = {
                            ...restOfQNA,
                            answerText: this.editorContent,
                            reviewId: this.qnaFlags.assignmentId,
                        };
                        this.send({ type: "SAVE_ANSWER", qna: updatedQna });
                        this.isAnswerDirty = false;
                    }
                });
            }
        }
        validateAnswer() {
            return new Promise((resolve, reject) => {
                if (this.questionAnswerAndComments.isMandatory && !this.editorContent) {
                    toaster.ShowError("Please provide answers for mandatory question");
                    resolve(false);
                }
                else {
                    resolve(true);
                }
            });
        }
        cancelEditor() {
            this.isAnswerDirty = false;
            this.editorContent = this.questionAnswerAndComments.answerText;
            this.send({ type: "CANCEL_EDITOR" });
        }
        modifyEditedComment(modifiedComment) {
            this.questionAnswerAndComments.commentItems.find((x) => x.id == modifiedComment.id).comments = modifiedComment;
            this.questionAnswerAndComments.clientCommentItems.find((x) => x.id == modifiedComment.id).comments = modifiedComment;
        }
        removeDeletedCommment(id) {
            this.questionAnswerAndComments.commentItems = this.questionAnswerAndComments.commentItems.filter((x) => x.id != id);
            this.questionAnswerAndComments.clientCommentItems = this.questionAnswerAndComments.clientCommentItems.filter((x) => x.id != id);
        }
        get orderedCommentItems() {
            return _.orderBy(this.questionAnswerAndComments.commentItems, (x) => x.timeStamp);
        }
        get orderedClientCommentItems() {
            return _.orderBy(this.questionAnswerAndComments.clientCommentItems, (x) => x.timeStamp);
        }
        sanitizeHtml(html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const anchorTags = doc.querySelectorAll("a");
            anchorTags.forEach((tag) => {
                tag.setAttribute("target", "_blank");
            });
            return doc.documentElement.innerHTML;
        }
        created() {
            console.log(this.questionAnswerAndComments);
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.state = state;
                console.log(this.state.toStrings());
            });
            this.initialize();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof PAReviewAnswerItemModel !== "undefined" && PAReviewAnswerItemModel) === "function" ? _a : Object)
    ], QuestionAndAnswerComponent.prototype, "questionAnswerAndComments", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_b = typeof qnaFlagsType !== "undefined" && qnaFlagsType) === "function" ? _b : Object)
    ], QuestionAndAnswerComponent.prototype, "qnaFlags", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], QuestionAndAnswerComponent.prototype, "hasAnswer", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], QuestionAndAnswerComponent.prototype, "clientAssignmentId", void 0);
    QuestionAndAnswerComponent = __decorate([
        Component({
            name: "QuestionAndAnswerComponent",
            components: {
                Loader,
                simplebar,
                EcTextEditor,
                CommentComponent,
                SectionLoader,
            },
        })
    ], QuestionAndAnswerComponent);
    return QuestionAndAnswerComponent;
})();
export default QuestionAndAnswerComponent;
